export default {
    upload_photos: {
        heading: 'Image Gallery',
        content: 'Images are great way to showcase your product and how good you are.',
    },
    schedule: {
        heading: 'Schedule',
        content_create: 'Create your schedules for the service',
        content: 'Your schedules',
    },
    buttons: {
        create_new: 'Create new',
        use_existing: 'Use existing',
        go_to_offers: 'Go to services',
    },
    categories: 'Categories',
    choose_existing: 'Choose existing availabilities',
    create_new: 'Create new availability',
    add_availability_to_offer:
        'If you choose a particular schedule, all the services on that schedule will use the same time period. This means that if you reserve a certain time period on the schedule, that time period will be unavailable for all services that share it.',
    remove_availability: 'Are you sure you want to remove this schedule from this service?',
}
